import { DateTime } from "luxon"
import getMessage from "../../utils/getMessage"
import calendarfilled from '../../../assets/images/calendarfilled.svg';
import classNames from "classnames";
import { Fragment } from "react";
import Icon from "../../utils/Icon";

const HearingInformationDates = ({
  hearing, 
  stateAlignRight = true,
  dl = false,
}) => {
  const openingDateTime = DateTime.fromISO(hearing.open_at)
  const closingDateTime = DateTime.fromISO(hearing.close_at)
  const now = DateTime.now()

  const isSameYear = (openingDateTime.year === closingDateTime.year)
  const isInCurrentYear = isSameYear && openingDateTime.year === now.year

  const openingDateFormat = isSameYear ? 'dd.MM.' : 'dd.MM.yyyy'

  const isSameDay = openingDateTime.startOf('day').ts == closingDateTime.startOf('day')
  
  const closingDateFormat = isSameDay ? '' : isInCurrentYear ? 'dd.MM' : 'dd.MM.yyyy'

  const openingTime = openingDateTime.toFormat('HH:mm');
  const closingTime = closingDateTime.toFormat('HH:mm');

  const openingDate = openingDateTime.toFormat(openingDateFormat);
  const closingDate = closingDateTime.toFormat(closingDateFormat);

  const nowIsBetweenTimes = now > openingDateTime.toMillis() && now < closingDateTime.toMillis();
  let hearingState = 'hearingClosed';
  if (hearing.published && nowIsBetweenTimes) {
    hearingState = 'published';
  } else if (!hearing.published) {
    hearingState = 'draft'
  }

  classNames

  if (dl) {
    return (
      <Fragment>
        <dt>
          <Icon name="calendar" aria-hidden="true" title={getMessage('hearingSchedule')}/>
          <span className="sr-only">{getMessage('hearingSchedule')}</span>
        </dt>
        <dd>
          <div>
            <span className='dateSpan'><span className="datePart">{openingDate}</span> {openingTime}</span>
            <span className='dateSpan'>&nbsp;-&nbsp;<span className="datePart">{closingDate}</span> {closingTime}</span>
          </div>
        </dd>
      </Fragment>
    )
  }

  return (
    <div>
      <div className="hearing-card-date">
        <img
          className="hearing-image"
          src={calendarfilled}
          style={{ color: '#7E23E7' }}
          alt={getMessage('hearingSchedule')}
        />
        <div className="hearing-card-value">
          <span className='dateSpan'><span className="datePart">{openingDate}</span> {openingTime}</span>
          <span className='dateSpan'>&nbsp;-&nbsp;<span className="datePart">{closingDate}</span> {closingTime}</span>
        </div>
      </div>
      <div>
        <div className={classNames(
          'hearing-state',
          hearingState,
          {'align-right': stateAlignRight}
        )}>{getMessage(hearingState)}</div>
      </div>
    </div>
  )
}

export default HearingInformationDates;